import { render, staticRenderFns } from "./AppointmentLogin.vue?vue&type=template&id=708da763"
import script from "./AppointmentLogin.vue?vue&type=script&lang=js"
export * from "./AppointmentLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports